<template>
    <section class="plugin-home-advantages">
        <div class="plugin-home-advantages__container">
            <plugin-home-common-title
                v-bind:text="title"
                theme="white"
            />

            <div class="plugin-home-advantages__content">
                <div class="plugin-home-advantages__content-left">
                    <div class="plugin-home-advantages__content-item"
                         v-bind:class="{ _active: item.id === activeId }"
                         v-for="item in leftItems"
                         v-bind:key="item.id"
                    >
                        <div class="plugin-home-advantages__content-item-title"
                             v-on:click="activeId = item.id"
                        >
                            <span>{{ item.title }}</span>
                            <div class="plugin-home-advantages__content-item-title-toggle">
                                <icon name="triangle" width="24" height="24" color="#FFF" />
                            </div>
                        </div>
                        <div class="plugin-home-advantages__content-item-text"
                             v-if="item.id === activeId"
                        >
                            {{ item.text }}
                        </div>
                    </div>
                </div>
                <div class="plugin-home-advantages__content-center">
                    <plugin-home-image
                        v-for="item in idsMappedItems"
                        v-bind:key="item.id"
                        v-bind:image="item.image"
                        v-bind:title="item.imageText"
                        v-show="item.id === activeId"
                        theme="white"
                        position="bottom"
                    />
                </div>
                <div class="plugin-home-advantages__content-right">
                    <div class="plugin-home-advantages__content-item"
                         v-bind:class="{ _active: item.id === activeId }"
                         v-for="item in rightItems"
                         v-bind:key="item.id"
                    >
                        <div class="plugin-home-advantages__content-item-title"
                             v-on:click="activeId = item.id"
                        >
                            <span>{{ item.title }}</span>
                            <div class="plugin-home-advantages__content-item-title-toggle">
                                <icon name="triangle" width="24" height="24" color="#FFF" />
                            </div>
                        </div>
                        <div class="plugin-home-advantages__content-item-text"
                             v-if="item.id === activeId"
                        >
                            {{ item.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'plugin-home-advantages-v2',
    props: {
        title: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        slider: null,
        activeId: 0,
    }),
    computed: {
        idsMappedItems() {
            let index = 0;
            return this.items.map(item => ({
                id: index++,
                ...item,
            }));
        },
        activeItem() {
            return this.idsMappedItems.find(item => item.id === this.activeId);
        },
        middle() {
            return Math.ceil(this.idsMappedItems.length / 2);
        },
        leftItems() {
            return this.idsMappedItems.slice(0, this.middle);
        },
        rightItems() {
            return this.idsMappedItems.slice(this.middle);
        },
    },
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-advantages {
    .container-landing();

    width: 100%;
    padding-top: 96px;
    padding-bottom: 96px;
    background-color: @color-gray-darker;

    &__container {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    &__content {
        flex: 1;
        display: flex;
        gap: 16px;

        &-center {
            position: relative;
            width: 100%;
            height: 560px;
        }
        &-left,
        &-right {
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            gap: 24px;
            width: 390px;
        }
        &-item {
            overflow: hidden;
            &-title {
                .typography-medium();

                display: flex;
                justify-content: space-between;
                align-items: center;

                padding: 16px 32px;

                color: @color-gray-lightest;

                border: 2px solid transparent;
                transition: border 0.3s;
                border-radius: @border-radius-lg;

                cursor: pointer;

                &:hover {
                    border: 2px solid white;
                }
                &-toggle {
                    flex-shrink: 0;
                    transform: rotate(-180deg);
                }
            }
            &._active {
                border-radius: @border-radius-xxl;
                background-color: #F1EBFC;
            }
            &._active &-title {
                padding-top: 32px;
                color: @color-primary;
                &:hover {
                    border: 2px solid transparent;
                }
                &-toggle {
                    display: none;
                }
            }
            &._active &-text {
                .typography-small();

                padding: 0 32px 32px 32px;
                color: @color-gray-darker;
            }
        }
    }
    @media @media-lg-down {
        &__content {
            &-center {
                display: none;
            }
        }
    }
    @media @media-md-down {
        padding-top: 40px;
        padding-bottom: 40px;
        &__container {
            gap: 12px;
        }
        &__content {
            flex-direction: column;
            gap:12px;
            &-center {
                display: block;
                height: 240px;
                order: -1;
            }
            &-left,
            &-right {
                width: auto;
                gap: 12px;
            }
            &-item {
                &-title {
                    .typography-small();

                    padding: 8px 12px;
                }
                &._active {
                    border-radius: @border-radius-xll;
                }
                &._active &-title {
                    padding: 24px 24px 6px 24px;
                    color: @color-primary;
                }
                &._active &-text {
                    .typography-heading();

                    padding: 0 24px 24px 24px;
                }
            }
        }
    }
}
</style>
